"use client";

import Image from "next/image";
import { useState } from "react";
import Container from "@/components/ui/Container";
import SectionTitle from "@/components/ui/SectionTitle";

const TOTAL = 34;
const INITIAL = 12;

const all = Array.from(
  { length: TOTAL },
  (_, i) => `/images/gallery/${String(i + 1).padStart(2, "0")}.jpg`,
);

export default function Gallery({
  title,
  showMore,
  showLess,
}: {
  title: string;
  showMore: string;
  showLess: string;
}) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? all : all.slice(0, INITIAL);

  return (
    <section className="bg-paper py-20 sm:py-24">
      <Container>
        <SectionTitle title={title} />
        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {visible.map((src, i) => (
            <div
              key={src}
              className="relative aspect-[4/3] overflow-hidden rounded-xl bg-navy/5"
            >
              <Image
                src={src}
                alt=""
                fill
                loading={i < 8 ? "eager" : "lazy"}
                sizes="(min-width: 1024px) 24vw, (min-width: 640px) 32vw, 48vw"
                className="object-cover transition-transform duration-500 hover:scale-105"
              />
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            className="rounded-full border border-navy/20 px-7 py-3 text-sm font-semibold text-navy transition-colors hover:bg-navy hover:text-white"
          >
            {expanded ? showLess : showMore}
          </button>
        </div>
      </Container>
    </section>
  );
}
